import { useSelector } from "react-redux";
import {
  openModal,
  closeModal,
  selectActiveModal,
  selectModalParams,
  ModalType,
  ModalParams,
} from "@/store/modalSlice";
import { useAppDispatch } from "./redux";

export function useModal() {
  const dispatch = useAppDispatch();
  const activeModal = useSelector(selectActiveModal);
  const params = useSelector(selectModalParams);

  const open = <T extends ModalType>(
    modal: T,
    modalParams?: ModalParams[T]
  ) => {
    dispatch(openModal({ modal, params: modalParams }));
  };

  const close = () => {
    dispatch(closeModal());
  };

  return {
    activeModal,
    params,
    openModal: open,
    closeModal: close,
    isOpen: (modal: ModalType) => activeModal === modal,
  };
}
